import type { Data } from "app/modules/api-client/queryTypes";
import { getFaviconUrl } from "app/services/sitesService/sitesUtils";

import type { AdsGalleryData } from "../hooks/useAdsGallery";

type IndustryAdItem = Data<"AdIntelligenceMarketingAssets", "adintelligenceIndustryRecentAdsList">["data"][number];

export const industryAdToGalleryData = (ad: IndustryAdItem): AdsGalleryData => ({
    activeDays: ad.activeDays,
    adType: ad.adType,
    campaignTitle: ad.campaignTitle,
    creativeId: ad.creativeId,
    creativeImageUri: ad.creativeImageUri,
    creativeType: ad.creativeType,
    dimensions: ad.dimensions,
    firstSeen: ad.firstSeen,
    lastSeen: ad.lastSeen,
    landingPage: ad.landingPage,
    videoUrl: ad.videoUrl,
    landingPagesLinks: ad.landingPage ? [ad.landingPage] : undefined,
    ...(ad.advertiserHostname
        ? { advertiser: ad.advertiserHostname, advertiserFavicon: getFaviconUrl(ad.advertiserHostname) }
        : {}),
});
